
const waveformHeights = [
  6, 6, 6, 6, 6, 15, 26, 29, 21, 11,
  26, 29, 22, 12, 11, 23, 39, 46, 36, 12,
  37, 47, 40, 23, 10, 10, 19, 26, 22, 9,
  19, 26, 22, 13, 6, 6, 6, 6,
];

export function Waveform({
  levels,
  active,
}: {
  levels: number[];
  active: boolean;
}) {
  return (
    <div
      className={`wave-row ${active ? "wave-live" : ""}`}
      aria-hidden="true"
    >
      {waveformHeights.map((defaultHeight, index) => {
        const level = levels[index] ?? 0;
        const height = active
          ? Math.max(3, Math.min(47, level * 47))
          : defaultHeight;

        return <span key={index} style={{ height: `${height}px` }} />;
      })}
    </div>
  );
}